import {isNil} from 'ramda';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Checkbox, Form, Header, Icon, Message, Table} from 'semantic-ui-react';
import styled from 'styled-components';
import {createSchoolSemester, retrieveSchoolSemesters, updateActiveSchoolSemester} from '../../api';
import {GreenButton} from '../../components/Button/ButtonMix';
import MenuButton from '../../components/Button/MenuButton';
import {CharcoalContainer} from '../../components/Container/ContainerMix';
import {getSchoolProperty, userHasRole} from '../../util/Session';
import {formatDate, formatIsoDate} from '../../util/Utils';

const FullHeightCharcoalContainer = styled(CharcoalContainer)`
  height: calc(100vh);
  overflow-y: auto;
`;

const StyledMessage = styled(Message)`
  min-height: inherit !important;
  @media only screen and (max-width: 767px) {
    min-height: 250px !important;
  }
`;

class SchoolSemesters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      semesters: [],
      startDate: '',
      endDate: '',
      pointsNeeded: null
    };
  }

  componentDidMount() {
    const {router} = this.props;

    const isAdmin = userHasRole('admin');
    if (!isAdmin) {
      router.push('/dashboard');
      return;
    }

    const schoolId = getSchoolProperty('id');
    this.setState({isLoading: true});

    return retrieveSchoolSemesters(schoolId)
      .then(response => {
        this.setState({isLoading: false, semesters: response.data.semesters});
      });
  }

  changeIsActive = semesterId => {
    const schoolId = getSchoolProperty('id');
    this.setState({isLoading: true});

    return updateActiveSchoolSemester(semesterId)
      .then(() => retrieveSchoolSemesters(schoolId))
      .then(response => {
        this.setState({isLoading: false, semesters: response.data.semesters});
      });
  };

  handleChange = (e, {name, value}) => this.setState({[name]: value});

  createNewSemester = () => {
    const {startDate, endDate, pointsNeeded} = this.state;

    if (isNil(startDate) || isNil(endDate) || isNil(pointsNeeded)) {
      return;
    }

    const schoolId = getSchoolProperty('id');
    this.setState({isLoading: true});

    return createSchoolSemester(schoolId, formatIsoDate(startDate), formatIsoDate(endDate), pointsNeeded)
      .then(() => retrieveSchoolSemesters(schoolId))
      .then(response => {
        this.setState({isLoading: false, semesters: response.data.semesters});
      });
  };

  render() {
    const {isLoading, semesters, startDate, endDate, pointsNeeded} = this.state;
    const {onClickSidebar} = this.props;

    return (
      <FullHeightCharcoalContainer>
        <MenuButton onClick={onClickSidebar}/>
        <Header as="h2" icon textAlign="center">
          <Icon name="calendar" circular/>
          <Header.Content>Interval dates</Header.Content>
        </Header>
        <StyledMessage
          icon="info circle"
          header="What is an interval date?"
          content="Interval is the date range that you want to calculate points for your students (eg - quarter or semester dates)"
        />
        <Header as="h4" textAlign="left">
          <Header.Content>Current schedule intervals</Header.Content>
        </Header>
        {
          isLoading ?
            <Icon name="circle notched" loading={isLoading}/> :
            (
              <Table unstackable sortable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      Start
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      End
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Points
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Active
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                {semesters.map(semester => (
                  <Table.Body key={semester.id}>
                    <Table.Row>
                      <Table.Cell>{formatDate(semester.start_date)}</Table.Cell>
                      <Table.Cell>{formatDate(semester.end_date)}</Table.Cell>
                      <Table.Cell>{semester.points_needed}</Table.Cell>
                      <Table.Cell collapsing>
                        <Checkbox slider checked={semester.is_active} onChange={() => this.changeIsActive(semester.id)}/>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                ))}
              </Table>
            )
        }

        <Header as="h4" textAlign="left">
          <Header.Content>Create new schedule interval</Header.Content>
        </Header>
        <Form onSubmit={this.createNewSemester}>
          <Form.Input value={startDate} label="Start date" type="text" name="startDate" placeholder="mm/dd/yyyy" onChange={this.handleChange} required/>
          <Form.Input value={endDate} label="End date" type="text" name="endDate" placeholder="mm/dd/yyyy" onChange={this.handleChange} required/>
          <Form.Input value={pointsNeeded} label="Points needed" type="number" name="pointsNeeded" placeholder="How many points need to be earned?" onChange={this.handleChange} required/>

          <GreenButton disabled={isLoading}>Create</GreenButton>
        </Form>

      </FullHeightCharcoalContainer>
    );
  }
}

SchoolSemesters.propTypes = {
  onClickSidebar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(SchoolSemesters);



// WEBPACK FOOTER //
// ./src/pages/Schools/SchoolSemesters.js